export default "__VITE_ASSET__5a89ce3f__"